// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var UserIndustry = function (x) {
    return x;
};
var tsBridgeUserIndustry = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("UserIndustry")("__brandUserIndustry"));
    }
};
var writeUserIndustry = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showUserIndustry = Data_Show.showString;
var readUserIndustry = Simple_JSON.readString;
var ordUserIndustry = Data_Ord.ordString;
var newtypeUserIndustry = {
    Coercible0: function () {
        return undefined;
    }
};
var makeUserIndustry = UserIndustry;
var eqUserIndustry = Data_Eq.eqString;
export {
    UserIndustry,
    makeUserIndustry,
    unwrap,
    newtypeUserIndustry,
    eqUserIndustry,
    ordUserIndustry,
    showUserIndustry,
    readUserIndustry,
    writeUserIndustry,
    tsBridgeUserIndustry
};
//# sourceMappingURL=index.js.map
